// extracted by mini-css-extract-plugin
export default {"MultiplePageTemplate":"MultiplePageTemplate_S6pf4","MultiplePageTemplate_progressBarWrapper":"MultiplePageTemplate_progressBarWrapper_xfi9x"};